var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.type == "form"
        ? [
            _c("b-skeleton", {
              staticClass: "mb-3 mt-3",
              attrs: { width: "85%" },
            }),
            _vm._v(" "),
            _c("b-skeleton", {
              staticClass: "mb-3 mt-3",
              attrs: { width: "55%" },
            }),
            _vm._v(" "),
            _c("b-skeleton", {
              staticClass: "mb-3 mt-3",
              attrs: { width: "70%" },
            }),
            _vm._v(" "),
            _c("b-skeleton", {
              staticClass: "mb-3 mt-3",
              attrs: { width: "85%" },
            }),
            _vm._v(" "),
            _c("b-skeleton", {
              staticClass: "mb-3 mt-3",
              attrs: { width: "55%" },
            }),
            _vm._v(" "),
            _c("b-skeleton", {
              staticClass: "mb-3 mt-3",
              attrs: { width: "70%" },
            }),
            _vm._v(" "),
            _c("b-skeleton", {
              staticClass: "mb-3 mt-3",
              attrs: { width: "85%" },
            }),
            _vm._v(" "),
            _c("b-skeleton", { attrs: { type: "input" } }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mb-5 mt-5 float-right" },
              [_c("b-skeleton", { attrs: { type: "button" } })],
              1
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.type == "card"
        ? [
            _c(
              "b-card",
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { sm: "10" } },
                      [
                        _c("b-skeleton", {
                          staticClass: "mb-3",
                          attrs: { width: "80%" },
                        }),
                        _vm._v(" "),
                        _c("b-skeleton", {
                          staticClass: "mb-3",
                          attrs: { width: "30%" },
                        }),
                        _vm._v(" "),
                        _c("b-skeleton", { attrs: { width: "25%" } }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { sm: "2" } },
                      [
                        _c("b-skeleton", {
                          staticClass: "mb-3",
                          staticStyle: { margin: "auto" },
                          attrs: { width: "50%" },
                        }),
                        _vm._v(" "),
                        _c("b-skeleton", {
                          staticStyle: { margin: "auto" },
                          attrs: { type: "avatar" },
                        }),
                        _vm._v(" "),
                        _c("b-skeleton", {
                          staticClass: "mt-1",
                          staticStyle: { margin: "auto" },
                          attrs: { width: "33%" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.type == "image"
        ? [
            _c(
              "b-card",
              { staticClass: "mb-4" },
              [
                _c(
                  "b-row",
                  { attrs: { "align-v": "center" } },
                  [
                    _c(
                      "b-col",
                      { attrs: { lg: "1", sm: "12" } },
                      [
                        _c("b-skeleton", {
                          staticClass: "m-4",
                          attrs: { type: "avatar", size: "5rem" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { lg: "8", sm: "12" } },
                      [
                        _c("b-skeleton", {
                          staticClass: "ml-5",
                          attrs: { width: "10%" },
                        }),
                        _vm._v(" "),
                        _c("b-skeleton", {
                          staticClass: "ml-5",
                          attrs: { width: "20%" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }